import { Component, OnInit, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { EVIDENCE_URL, DISPLAY_DATE_FORMAT } from 'src/app/app.constants';
import { Evidence, TableDataEvidence, Capa } from '../../audit.model';
import { TableData, TableOptions, BreadcrumbItem, RequestResult } from 'src/app/shared/shared.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { EvidenceService } from '../../evidence.service';
import { tap, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CapaService } from '../../capa.service';

@Component({
  selector: 'iaud-evidence-update-history',
  templateUrl: './evidence-update-history.component.html',
  styleUrls: ['./evidence-update-history.component.scss']
})
export class EvidenceUpdateHistoryComponent implements OnInit {  

  evUrl = EVIDENCE_URL;
  
  evidenceTableData: TableData<Evidence>;
  forceReloadEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  hasInitialEvidences: boolean = false;
  
  findingId: number;
  capaId: number;  
  capa: Capa;

  evidenceTableOptions: TableOptions = {    
    actionButtons: false,
    hideEditButton : true,
    hideDeleteButton : true,
    columns: [
      {
        title: 'Evidence ID',
        fieldName: 'evidenceId',
      },
      {
        title: 'Evidence File',
        fieldName: 'fileName',
      },
      {
        title: 'Status',
        fieldName: 'status',
      },
      {
        title: 'Reason',
        fieldName: 'reason',
      },
      {
        title: 'Created By',
        fieldName: 'createdBy',
      },
      {
        title: 'Created Date',
        fieldName: 'createdOn',
        pipe: new DatePipe('en-US'),
        pipeParams: DISPLAY_DATE_FORMAT,
      },
      {
        title: 'Updated By',
        fieldName: 'modifiedBy',
      },
      {
        title: 'Updated Date',
        fieldName: 'modifiedOn',
        pipe: new DatePipe('en-US'),
        pipeParams: DISPLAY_DATE_FORMAT,
      },
    ],
    additionalInfo: [
      {
        title: 'Evidence Description',
        fieldName: 'description',
      },
    ],
  };

  breadcrumbs: Array<BreadcrumbItem> = [
    {
      title: 'Home',
      path: '/home',
    },
    {
      title: 'All audits',
      path: '/audit',
    },
  ];

  canAddEvidence: boolean;

  @ViewChild('fileCellTemplate') fileCellTemplate: TemplateRef<any>;

  constructor(    
    private route: ActivatedRoute,  
    private capaService: CapaService,  
    private evidenceService: EvidenceService) { 

    }

  ngOnInit(): void {
    this.route.paramMap.pipe(
      switchMap((params: ParamMap): Observable<Capa> => {
        
        this.findingId = +params.get('findingId');
        this.capaId = +params.get('capaId');        

        return this.capaService.getCapa(this.capaId);
      })
    )
      .subscribe(v => {
        this.capa = v;               
      });
    this.refreshData();
  }

  refreshData(): void {
    this.reloadEvidenceListHistory()
      .subscribe(table => {
        this.evidenceTableData = table;
        this.hasInitialEvidences = table.items.length > 0;
      });
      
  }

  ngAfterContentChecked(): void {
    this.evidenceTableOptions.columns[1].customTemplate = this.fileCellTemplate;
  }

  reloadEvidenceListHistory(): Observable<TableDataEvidence<Evidence>> {
    return this.evidenceService.getEvidenceListHistory(this.capaId)
      .pipe(
        tap(table => this.canAddEvidence = table.canAddEvidence)
      );
  }  

  deleteData(): Observable<RequestResult> {
    return null;
  }

  editEvidence(): Observable<RequestResult> {
    return null;
  }
    
}

